"use client";

import { useState } from "react";
import { Send, Loader2 } from "lucide-react";

export function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");

    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const json = (await res.json().catch(() => ({}))) as {
        error?: string;
        already_confirmed?: boolean;
      };
      if (!res.ok) {
        throw new Error(json.error || "Fehler bei der Anmeldung.");
      }

      // Double-Opt-In: Das Abo ist erst nach Klick auf die Bestätigungs-Mail
      // aktiv – das muss die Meldung auch so sagen (kein „angemeldet!").
      setSuccessMsg(
        json.already_confirmed
          ? "Sie sind bereits angemeldet – alles gut."
          : "Fast geschafft! Bitte bestätigen Sie den Link in Ihrer E-Mail.",
      );
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 7000);
    } catch (err) {
      setStatus("error");
      setErrorMsg(err instanceof Error ? err.message : "Fehler bei der Anmeldung.");
      setTimeout(() => setStatus("idle"), 4000);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-Mail-Adresse"
          required
          disabled={status === "loading"}
          className="flex-1 rounded-lg border px-3 py-2 text-sm outline-none transition-colors focus:border-primary disabled:opacity-50"
          style={{
            backgroundColor: "var(--bg)",
            borderColor: "var(--border)",
            color: "var(--text)",
          }}
          aria-label="E-Mail für Newsletter"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="rounded-lg bg-primary p-2 text-white transition-colors hover:bg-primary-dark disabled:opacity-50"
          aria-label="Newsletter abonnieren"
        >
          {status === "loading" ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Send className="h-4 w-4" />
          )}
        </button>
      </form>
      {status === "success" && (
        <p className="mt-2 text-xs text-brand-500 font-medium">
          {successMsg}
        </p>
      )}
      {status === "error" && (
        <p className="mt-2 text-xs font-medium" style={{ color: "var(--color-error)" }}>
          {errorMsg}
        </p>
      )}
    </div>
  );
}
